import React from "react";

import { ReactComponent as TimeTableHeaderImage } from "assets/img/svg/TimeTableHeaderImage.svg";
import ModuleCards from "./ModuleCards";
const styles = {
  backgroundColor: "#002331",
  height: "130px",
  width: "100%",
  color: "#FFFFFF",
  padding: "2rem 1rem",
  display: "flex",
  alignItems: "center"
};







const EntryPointTopHeader = () => {
  return (
    <div className='d-flex flex-column justify-content-between remove-container-top-space'>
    <div style={styles}>
      <div
        className="d-flex flex-column align-items-start justify-content-between"
        style={{ flex: 1, height: "100%" }}
      >
        <div>
          <h3 style={{ fontSize: "28px", fontWeight: 700, color: "inherit" }}>
            Payment Management
          </h3>
        </div>
      </div>
      <TimeTableHeaderImage />
    </div>
    <ModuleCards/>
    </div>
  );
};

export default EntryPointTopHeader;
